export class PostsList {
    constructor() {
        this.setProperties();
        this.setEvents();
        this.checkPostsHeight();
    }

    setProperties() {
        this.$lists = $( '.posts-even-height' );
    }

    setEvents() {
        let $ticketSelectDay = $( '.ticket-select-day' ),
            $ticketSelectTime = $( '.ticket-select-time' );

        $( window ).on( 'resize', () => { this.checkPostsHeight(); } );

        $( document ).ready( () => this.checkPostsHeight() );

        $ticketSelectDay.on( 'click tap', ( event ) => {
            event.preventDefault();
            event.stopPropagation();
        } );

        $ticketSelectTime.on( 'click tap', ( event ) => {
            event.preventDefault();
            event.stopPropagation();
        } );

        $ticketSelectDay.on( 'change', function() {
            let $this = $( this ),
                $selectTimeOld = $this.siblings( '.ticket-select-time:not(.d-none)' ),
                $selectTimeNew = $this.siblings( '.ticket-select-time[data-day="' + $this.val() + '"]' );

            $selectTimeOld.addClass( 'd-none' );
            $selectTimeNew.removeClass( 'd-none' ).trigger( 'change' );
        } );

        $ticketSelectTime.on( 'change', function() {
            let $this = $( this ),
                $parent = $this.closest( $this.attr( 'data-parent' ) ),
                $button = $parent.find( '.ticket-link' ),
                href = $button.attr( 'href' ),
                newHref = $button.attr( 'href' );

            if ( href ) {
                newHref = href.substring( 0, href.lastIndexOf( '=' ) + 1 ) + $this.val();
            }

            $button.attr( 'href', newHref );
        } );

        $ticketSelectDay.trigger( 'change' );
    }

    checkPostsHeight() {
        this.$lists.each( function() {
            let $list = $( this ),
                $postsContent = $list.find( '.post-bottom' ),
                topHeight = 0;

            $postsContent.css( 'height', 'auto' );

            $postsContent.each( function() {
                let currentHeight = $( this ).height();

                if ( currentHeight > topHeight ) {
                    topHeight = currentHeight;
                }
            } );

            $postsContent.css( 'height', topHeight + 20 + 'px' );
        } );
    }
}
